<div class="organization-preferences" *ngIf="userRole?.includes('OrganizationAdmin') || userDetails.role == 'OrganizationAdmin'">
  <div class="preference-heading">
    <div class="preference-heading-text">Company Preferences</div>
    <div class="preferences-tabs">
        <mat-button-toggle-group 
        name="fontStyle"
        value="{{orgTabValue}}"
        [(ngModel)]="companyPreferenceTab"
        name="fontStyle" aria-label="Font Style"
        >
           <mat-button-toggle *ngFor="let category of orgCategories; let i = index" 
            [value]="category.preferenceGroupId">
             {{category.groupLabel}}
           </mat-button-toggle>
       </mat-button-toggle-group>
    </div>
    <div class="organization-preferences-form-block">
        <form #organizationPreferencesForm="ngForm" class="organization-preferences-form">
          <div *ngFor=" let categories of companyPreferences; let categoryIndex = index">
              <div [hidden]="!(companyPreferenceTab === categories[0].preferenceGroupId)" class="categories-header">
                  <div class="categories-header-label">
                    Event name
                  </div>
                  <div class="categories-header-action-label">
                      
                    </div>
                  <div class="categories-header-action-label">
                    ON/OFF
                  </div>
                </div>
            <div [hidden]="!(companyPreferenceTab === categories[0].preferenceGroupId)"  *ngFor=" let inputAttribute of categories; let  attrIndex = index" class="form-attributes preferences-form-attributes">
              
              <!-- <div *ngIf="inputAttribute.type == 'TEXT'">
                  <div class="input-attribute-label">{{inputAttribute.label}}</div>
                  <mat-form-field class="integration-name-mat-field">
                    <input matInput type="text" name="{{inputAttribute.name}}" #touchedText="ngModel"
                            placeholder=" {{inputAttribute.label}}" [(ngModel)]="inputAttribute.value"
                          (ngModelChange)="onTextValueChange(inputAttribute, 'company')"
                          [maxlength]="inputAttribute.maxLength" 
                          [required]="inputAttribute.required">
                  </mat-form-field>
              </div> -->

              <!-- <div class="checkbox-section" *ngIf="inputAttribute.type == 'CHECKBOX'" >
                  <div class="input-attribute-label">{{inputAttribute.label}}</div>
                  <section class="checkbox-children-section">
                    <div class="checkbox-bottom-section">
                      <mat-checkbox class="checkbox-children"
                                    *ngFor="let v of inputAttribute.possibleValues"
                                    name="{{inputAttribute.name}}" [(ngModel)]="v.selected"
                                    (change)="onCheckBoxChanged(inputAttribute, v, $event, 'company')"
                                    [ngModelOptions]="{standalone: true}">
                        <div class="input-labels" title="{{v.group}}">{{v.group}}</div>
                      </mat-checkbox>
                    </div>
                  </section>
              </div> -->

              <div *ngIf="inputAttribute.type == 'SWITCH'" class="preference-row">
                  <div class="input-attribute-label input-attribute-action-label">{{inputAttribute.label}}</div>
                  <div class="input-attribute-action">
                                          <mat-checkbox class="checkbox-children" *ngIf="(inputAttribute.enforced != null && (userRole?.includes('OrganizationAdmin') || userDetails.role == 'OrganizationAdmin'))" 
                      name="{{inputAttribute.name}}" [(ngModel)]="inputAttribute.selected"
                      (change)="onEnforceChanged(inputAttribute, $event, 'company')"
                      [ngModelOptions]="{standalone: true}">
                      </mat-checkbox>
                      <ui-switch  size="small" class="integration-pause"
                      [checked]="inputAttribute.value === 'true'"
                      [disabled]="(inputAttribute.enforced == 'true' &&  (!userRole?.includes('OrganizationAdmin') || userDetails.role != 'OrganizationAdmin')) "
                      (valueChange)="onSwitchChange(inputAttribute, $event, 'company')">
                      </ui-switch>
                  </div>
              </div>

            </div>
          </div>
        </form>  
    </div>
  </div>
  
</div>
<div class="user-preferences">
    <div class="preference-heading">
        <div class="preference-heading-text">User Preferences</div>
        <div class="preferences-tabs">
            <mat-button-toggle-group 
            name="fontStyle"
            value="{{userTabValue}}"
            [(ngModel)]="userPreferenceTab"
            name="fontStyle" aria-label="Font Style"
            >
               <mat-button-toggle *ngFor="let category of userCategories; let i = index" 
                [value]="category.preferenceGroupId">
                 {{category.groupLabel}}
               </mat-button-toggle>
           </mat-button-toggle-group>
        </div>
        <div class="organization-preferences-form-block">
            <form #userPreferencesForm="ngForm" class="organization-preferences-form">
              <div *ngFor=" let categories of userPreferences; let userIndex = index">
                <div [hidden]="!(userPreferenceTab === categories[0].preferenceGroupId)" class="categories-header">
                  <div class="categories-header-label">
                    Event name
                  </div>
                  <div *ngIf="(userRole?.includes('OrganizationAdmin') || userDetails.role == 'OrganizationAdmin')" 
                    class="categories-header-action-label" 
                    title="Selecting this will forcefully apply the preference to your users">
                      Enforce 
                    </div>
                    <div class="categories-header-action-label">
                        ON/OFF
                    </div>
                </div>
                <div [hidden]="!(userPreferenceTab === categories[0].preferenceGroupId)"  *ngFor=" let inputAttribute of categories; let  attrIndex = index" class="form-attributes preferences-form-attributes">
                  
                  
                  <!-- <div *ngIf="inputAttribute.type == 'TEXT'">
                      <div class="input-attribute-label">{{inputAttribute.label}}</div>
                      <mat-form-field class="integration-name-mat-field">
                        <input matInput type="text" name="{{inputAttribute.name}}" #touchedText="ngModel"
                                placeholder=" {{inputAttribute.label}}" [(ngModel)]="inputAttribute.value"
                              (ngModelChange)="onTextValueChange(inputAttribute, 'user')"
                              [maxlength]="inputAttribute.maxLength" 
                              [required]="inputAttribute.required">
                      </mat-form-field>
                  </div> -->
                  
                  <div *ngIf="inputAttribute.type == 'SWITCH'" class="preference-row">
                      <div class="input-attribute-label input-attribute-action-label">{{inputAttribute.label}}</div>
                      <div class="input-attribute-action">
                        <mat-checkbox class="checkbox-children" *ngIf="(inputAttribute.enforced != null && (userRole?.includes('OrganizationAdmin') || userDetails.role == 'OrganizationAdmin'))" 
                        name="{{inputAttribute.name}}" [(ngModel)]="inputAttribute.selected"
                        (change)="onEnforceChanged(inputAttribute, $event, 'user')"
                        [ngModelOptions]="{standalone: true}">
                        </mat-checkbox>

                        <div class="dummy-preference-action-block {{!(userRole?.includes('OrganizationAdmin') || userDetails.role == 'OrganizationAdmin') ? 'hide-this': ''}}" 
                          *ngIf="!(userRole?.includes('OrganizationAdmin') || userDetails.role == 'OrganizationAdmin')">
                        </div>

                        <ui-switch  size="small" class="integration-pause"
                          [checked]="inputAttribute.value === 'true'"
                          [disabled]="(inputAttribute.enforced  &&  (!userRole?.includes('OrganizationAdmin') || userDetails.role != 'OrganizationAdmin')) "
                          (valueChange)="onSwitchChange(inputAttribute, $event, 'user')">
                        </ui-switch>

                      </div>
                  </div>

            
                </div>    
              </div>
            </form>  
        </div>
      </div>
  </div>